import { createLogger } from '../../../shared/helpers/loggerFacade';

const logger = createLogger('sagas-error-handlers');

export const sagaErrorHandler = (sagaName: string) => (error: unknown | Error) => {
    logger.error(error, {
        block: sagaName,
        method: 'sageErrorHandler',
        level: window.Ya.Rum.ERROR_LEVEL.ERROR,
    });
};
